import React from 'react'
import { Redirect, Route, RouteProps } from 'react-router-dom'
import {
  SocialmediaConnection,
  SocialmediaConnectionState,
} from '@professocialApi/professocial-core-frontend-api/models'
import { useSelector } from 'react-redux'
import { getTokenChanged, getUser } from '../store/common/common.selectors'

const WithConnectRoute = ({ component: Component, path, children }: RouteProps) => {
  const user = useSelector(getUser)
  const tokenChanged = useSelector(getTokenChanged)

  if (!user || !tokenChanged) {
    return null
  }

  const connections = user.smConnections?.find((connection: SocialmediaConnection) => connection.state === SocialmediaConnectionState.Connected)

  if (!connections) {
    return <Redirect to={`/${user.role.toLowerCase()}/settings/connect`} />
  }

  return children
    ? <Route path={path}>{children}</Route>
    : <Route component={Component} path={path} />
}

export default WithConnectRoute
